<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>联系人</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.entity_name">
                <el-input v-model="entity_name" placeholder="请输入实体名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.province_rid">
                <el-select filterable v-model="province_rid" placeholder="请选择省份" clearable @change="provinceChange">
                    <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.city_rid">
                <el-select v-model="city_name" placeholder="请选择城市" clearable filterable value-key="value" @change="cityChange">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增关联实体</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="contact"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="contact"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'code' || item.prop == 'name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'entities'">
                                <span
                                    v-for="(item, index) in scope.row.entities"
                                    :key="index"
                                    style="display: inline-block; margin-right: 20px"
                                    >{{ item }}</span
                                >
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'contactComponent',
    data() {
        return {
            draggable: {
                data_name: 'contact'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            code: '', //code
            name: '', // 记录ID
            province_rid: '', // 省ID
            city_rid: '', // 市ID
            city_name: '',
            entity_name: '', //实体名称
            provincesOptions: [], //省份列表
            cityOptions: [] //城市列表
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['contact_params']) {
                this.page = paramsList['contact_params'].page;
                this.row = paramsList['contact_params'].row;
                this.name = paramsList['contact_params'].name;
                // this.data_name = paramsList['contact_params'].data_name;
                // this.sort = paramsList['contact_params'].sort;
                this.code = paramsList['contact_params'].code;
                this.entity_name = paramsList['contact_params'].entity_name;
                this.city_rid = paramsList['contact_params'].city_rid;
                this.city_name = paramsList['contact_params'].city_name;
                this.province_rid = paramsList['contact_params'].province_rid;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getProvinces(); //获取省份
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                if (this.postList.params.account_rid) {
                    this.getList(0); //获取列表
                }
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('contact', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).contact;
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'contactEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'contactEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .contactDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contact_params']) {
                    newParamsList['contact_params'].data_name = val.prop;
                    newParamsList['contact_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //省份改变请求当下省份下的城市
        provinceChange() {
            this.cityOptions = [];
            this.city_rid = '';
            this.city_name = '';
            if (this.province_rid) {
                let params = {
                    parent_rid: this.province_rid
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            }
        },
        //新增
        addAcount() {
            if (this.postList.params) {
                if (this.postList.params.entity_name) {
                    this.$router.push({
                        path: '/contactEdit',
                        query: {
                            type: 4,
                            entity_type: 'partner',
                            partner_name: this.postList.params.entity_name,
                            partner_id: this.postList.params.entity_rid
                        }
                    });
                }
            } else {
                this.$router.push({
                    path: '/contactEdit',
                    query: {
                        type: 3
                    }
                });
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                this.$router.push({
                    path: '/contactDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        cityChange(value) {
            if (value) {
                this.city_name = value.label;
                this.city_rid = value.value;
            } else {
                this.city_name = '';
                this.city_rid = '';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                name: this.name,
                code: this.code,
                entity_name: this.entity_name,
                city_rid: this.city_rid,
                city_name: this.city_name,
                sort: [this.data_name, this.sort],
                province_rid: this.province_rid,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['contact_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .contactLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['contact_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .contactListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contact_params']) {
                    newParamsList['contact_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        code: this.code,
                        entity_name: this.entity_name,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        sort: [this.data_name, this.sort],
                        province_rid: this.province_rid
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['contact_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['contact_params']) {
                    newParamsList['contact_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        code: this.code,
                        entity_name: this.entity_name,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        sort: [this.data_name, this.sort],
                        province_rid: this.province_rid
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['contact_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.name = '';
            this.province_rid = '';
            this.city_rid = '';
            this.city_name = '';
            this.entity_name = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                code: '',
                name: '',
                province_rid: '',
                city_rid: '',
                city_name: '',
                entity_name: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['contact_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>